/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChartSeries } from './chartSeries';


/**
 * A chart visualisation (bar, line, scatter, or pie) built from one or more named series plotted against shared category labels.
 */
export interface ChartBlock { 
    /**
     * Discriminator identifying this block as a chart.
     */
    type?: ChartBlock.TypeEnum;
    /**
     * Chart heading, for example \'Site risk comparison\'.
     */
    title: string;
    /**
     * Visual style of the chart.
     */
    chartType: ChartBlock.ChartTypeEnum;
    /**
     * Optional caption beneath the chart for context, such as describing a reference line, for example \'Dashed reference line: enterprise average IPAH (0.126)\'.
     */
    footnote?: string | null;
    /**
     * The data series to plot.
     */
    series?: Array<ChartSeries>;
    /**
     * Category labels shared across all series, positionally aligned with each series\' `data` (for example the x-axis categories or time buckets).
     */
    labels?: Array<string>;
    /**
     * Optional title for the category (x) axis, for example \'Operator rank\'.
     */
    xAxisTitle?: string | null;
    /**
     * Optional title for the value (y) axis, for example \'Cumulative impact share (%)\'.
     */
    yAxisTitle?: string | null;
    /**
     * Optional sub-heading shown with the chart, for example the analysis window \'31 days\'.
     */
    subtitle?: string | null;
}
export namespace ChartBlock {
    export const TypeEnum = {
        Chart: 'chart'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const ChartTypeEnum = {
        Bar: 'bar',
        Line: 'line',
        Scatter: 'scatter',
        Pie: 'pie'
    } as const;
    export type ChartTypeEnum = typeof ChartTypeEnum[keyof typeof ChartTypeEnum];
}


